module.exports = __webpack_public_path__ + "static/media/project.de91440f.jpg";